export default {
    dependencies: [
        '$element',
        'finnstream',
        'templateservice',
        '$controllerator',
        'trackingservice',
    ],
    callable(
        ele,
        finnstream,
        templateservice,
        controllerator,
        trackingservice
    ) {
        finnstream
            .getSiteStreamCached()
            .then(handleCachedItems, handleStreamError);
        const streamPromise = finnstream.getSiteStream();

        const spinner = ele.querySelector('[data-spinner]');

        function setStreamContent(htmlString) {
            ele.innerHTML = htmlString;
            controllerator.run();
        }

        function addStreamItems(items) {
            setStreamContent(
                templateservice.render('stream', { stream: items })
            );
        }

        function handleCachedItems(items) {
            streamPromise.then(handleNewItems);
            hideSpinner();

            if (items.length === 0) {
                return;
            }

            items.forEach(addTrackingToUrl);
            addStreamItems(items);

            const fragId = window.location.hash;
            if (fragId) {
                const id = fragId.slice(1);
                const targetEle = document.querySelector(`[id='${id}']`);
                if (targetEle) {
                    targetEle.scrollIntoView();
                    targetEle.focus();
                }
            }
        }

        function handleNewItems(items) {
            if (items.length === 0) {
                return;
            }

            items.forEach(addTrackingToUrl);
            trackShowStreamItems(items); // only track new items

            if (
                document.body.scrollTop !== 0 ||
                document.documentElement.scrollTop !== 0
            ) {
                showNewItemsButton(() => {
                    setTimeout(() => {
                        addStreamItems(items);
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                    }, 50); // 0 did not work, unsure why
                });
            } else {
                addStreamItems(items);
            }
        }

        function handleStreamError(err) {
            streamPromise.then(handleNewItems);
            console.log('error loading stream:', err);
        }

        function showNewItemsButton(handleClick) {
            const buttonEle = document.createElement('button');
            const spanEle = document.createElement('span');
            buttonEle.className =
                'blank t3 fit-height strong load-new-stream-items-button';
            buttonEle.addEventListener('click', () => {
                handleClick();
                buttonEle.remove();
            });
            spanEle.textContent = 'Vis nye';
            spanEle.className = 'button-emphasis button-emphasis-inverse';
            buttonEle.appendChild(spanEle);
            ele.appendChild(buttonEle);
            window.setTimeout(() => {
                buttonEle.style.opacity = '1';
            });
        }

        function addTrackingToUrl(item) {
            if (item.type === 'new-ad-on-alert') {
                const url = new URL(item.url, document.baseURI);
                url.searchParams.set('trel', 'storedsearch');
                item.url = url.toString();
            }

            if (item.adItems && item.adItems.length) {
                item.adItems.forEach(e => {
                    const url = new URL(e.url, document.baseURI);
                    url.searchParams.set('trel', 'ad');
                    if (e.trackingCode) {
                        url.searchParams.set('ecid', `${e.trackingCode}.click`);
                    }
                    e.url = url.toString();
                });
            }

            if (item.messageItems && item.messageItems.length) {
                item.url += '&trel=finnbox_stream_click_group';
                item.moreHitsUrl += '&trel=finnbox_stream_click_more_hits';
                item.messageItems.forEach(e => {
                    e.url += '&trel=finnbox_stream_click_message';
                });
            }
        }

        function trackShowStreamItems(items) {
            // eslint-disable-next-line prefer-spread
            const adItems = [].concat.apply(
                [],
                items.map(item => item.adItems)
            );

            // eslint-disable-next-line max-len
            const filteredItems = adItems.filter(
                item =>
                    typeof item !== 'undefined' &&
                    item.trackingCode &&
                    item.trackingCode !== 'undefined'
            );

            filteredItems.forEach(item => {
                trackingservice.trackEventObject({
                    ecType: 'USER',
                    ecCategory: `${item.trackingCode}.show`,
                    context: {
                        finnkode: item.id,
                    },
                });
            });
        }

        function hideSpinner() {
            if (spinner) {
                spinner.remove();
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnStreamLoader.js